<style lang="less" scoped>
@import '../../../style/common/variable';
ul,li {padding: 0;margin: 0;list-style: none;}
.Ky {position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;margin-bottom: 60px;}
.national {width: 1200px;}
.first {display: flex;justify-content: space-between;margin-top: 17px;
  .news {width: 779px;margin-left: 26px;
    .top {text-align: left;height: 40px;
      h3 {font-size: 18px;line-height: 40px;letter-spacing: 1px;;margin: 0;
        i {font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
      }
    }
  }
}
.kyxxMap {width: 1200px;height: 116px;background-color: rgba(0, 0, 0, 0.5);margin: 40px 0px;cursor: pointer;
  img {width: 100%;height: 100%;border-radius: 2px;}
}
.second {width: 1200px;margin-bottom: 10px;;display: flex;justify-content: space-between;align-items: center;
  .secondbox {height: 347px;width: 390px;
    .header {width: 100%;height: 40px;
      h3 {line-height: 40px;letter-spacing: 1px;;margin: 0;text-align: left;font-size: 18px;
        i {font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
      }
    }
  }
}
.third {width: 1200px;
  .kyxm {margin-top: 18px;
    .lr {height: 40px;width: 100%;display:flex;justify-content:space-between;
      .left {text-align: left;width: 50%;height: 40px;
        h3 {font-size: 18px;line-height: 40px;letter-spacing: 1px;;margin: 0px;
          i {font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
        }
      }
      .right {cursor: pointer;width: 50%;text-align: right;
        span {line-height:40px;;font-weight: 600;cursor: pointer;margin: 0;}
      }
    }
  }
}
.fourth {width: 1200px;
  .listbox{margin-bottom: 40px;}
  .showlist { margin-bottom: 40px;
    .header {height: 40px;width: 100%;display:flex;justify-content:space-between;
      .left {text-align: left;width: 50%;height: 40px;
        h3 {font-size: 18px;line-height: 40px;letter-spacing: 1px;;margin: 0px;
          i {font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
        }
      }
      .right {cursor: pointer;cursor: pointer;width: 50%;text-align: right;height: 40px;
        span {line-height: 40px;;font-weight: 600;margin: 0px;cursor: pointer;}
      }
    }
  }
  /deep/.el-tabs__content { height: 280px; }
  /deep/ .el-tabs__active-bar {width: 150px;background-color: #40bafd;}
  /deep/.el-tabs__item {color: #aaaaaa;padding: 0;;width: 150px;font-family: AlibabaPuHuiTi-Bold;font-size: 14px;line-height: 40px;letter-spacing: 1px;}
  /deep/.el-tabs__item:hover {color: #40bafd;}
  /deep/ .el-tabs__item.is-active {color: #40bafd;}
}
.lookmore{margin: 5px 0px;float: right;}
.lookmore:hover{color: #40bafd;cursor: pointer;}

@media screen and (max-width: @max-screen){
  .first{flex-wrap: wrap;
    .countries{width: 100vw;}
    .news{width: 100vw; margin-left: 0}
    .top{width: 94vw; margin-left: 3vw;}
    .lookmore{margin: .05rem 0.07rem !important;}
  }
  .kyxxMap{width: 100vw; height: .5rem;
    img{width: 100vw; height: .5rem;}
  }
  .second{flex-wrap: wrap; width: 94vw;
    .header{width: 96vw !important;height: auto !important;
      h3{font-size: .15rem !important;}
    }
  }
  .secondbox.dzky{ width: 94vw;height: auto !important;}
  .second .secondbox{height: auto!important; margin-bottom: .1rem}
  .Ky{margin-bottom: 0}
}
</style>
<!--安进 2021.7.2 东盟矿业 -->
<template>
  <div class="Ky">
    <National></National>
    <div class="first">
      <Countries class="countries" :Introduce ="introducedata" @DmkyClick="DmkyDetails"></Countries>
      <div class="news">
        <div class="top">
          <h3><i class="iconfont icon-tubiaozhuanqu-02"></i>资讯动态 / NEWS</h3>
        </div>
        <div class="bottom">
          <Information :Information="informationdata" @handleClick="KyzxDetails" ></Information>
          <p class="lookmore" @click="goKYZXList">查看 >></p>
        </div>
      </div>
    </div>
    <div class="kyxxMap">
      <img src="/static/images/zlkindex/矿业信息地图横幅.png" alt="" @click="goMap" />
    </div>
    <div class="second">
      <div class="secondbox dzky">
        <div class="header">
          <h3><i class="iconfont icon-tubiaozhuanqu-02"></i>地质矿产 / Geology and mineral</h3>
        </div>
        <DmkyList :List="DZKYdata" @clickListNews="ZlkDetails"></DmkyList>
      </div>
      <div class="secondbox zcfg">
        <div class="header">
          <h3><i class="iconfont icon-tubiaozhuanqu-02"></i>政策法规 / Policies and regulations</h3>
        </div>
        <DmkyList :List="ZCFGdata" @clickListNews="ZlkDetails"></DmkyList>
      </div>
      <div class="secondbox tzhj">
        <div class="header">
          <h3><i class="iconfont icon-tubiaozhuanqu-02"></i>投资环境 / Policies and regulations</h3>
        </div>
        <DmkyList :List="TZHJdata" @clickListNews="ZlkDetails"></DmkyList>
      </div>
    </div>
  </div>
</template>

<script>
import arrayFun from '../method/array.js'
import National from '../assembly/National.vue'
import Countries from '../assembly/Countries.vue'
import Information from '../assembly/Information.vue'
import DmkyList from '../assembly/DmkyList.vue'
import MiningPproject from '../assembly/MiningPproject.vue'
import TabsListDMKC from '../assembly/TabListDMKC.vue'
export default {
  components: {
    National,
    DmkyList,
    Countries,
    Information,
    MiningPproject,
    TabsListDMKC
  },
  name: '',
  data()
  {
    return {
      //国家ID，判断点击的那个国家
      ID: null,
      //所属国家
      ssgj: null,
      //地质矿产
      DZKYdata: [],
      //政策法规
      ZCFGdata: [],
      //投资环境
      TZHJdata: [],
      //国家介绍信息（数据库暂时只有中国的相关数据）
      introducedata: {},
      //国家信息介绍详情
      introduceContent: null,
      //资讯动态(数据超过6条时待处理)
      informationdata: [],
      //矿业项目数据
      miningdatas: [],
      //列表数据
      list1: {
        icon: 'iconfont icon-mineral',
        tabsList: [
          {id: '1', title: '矿产品供应', listdata: []},
          {id: '2', title: '矿产品求购', listdata: []}
        ]
      },
      list2: {
        icon: 'iconfont icon-zhubao',
        tabsList: [
          {id: '1', title: '珠宝玉石供应', listdata: []},
          {id: '2', title: '珠宝玉石求购 ', listdata: []}
        ]
      },
      list3: {
        icon: 'iconfont icon-wajueji',
        tabsList: [
          {id: '1', title: '矿业设备供应', listdata: []},
          {id: '2', title: '矿业设备求购', listdata: []}
        ]
      },
      list4: {
        icon: 'iconfont icon-fuwuerji',
        tabsList: [
          {id: '1', title: '矿业技术供应', listdata: []},
          {id: '2', title: '矿业技术求购', listdata: []}
        ]
      }
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.ID = +nval.query.id
        this.judgeCountries()
        this.getCountries()
        this.getNewsdata()
        this.getLatest()
        this.getminingdata()
        this.getListdata()
      },
      immediate: true
    }
  },
  methods: {
    judgeCountries()
    {
      switch (this.ID)
      {
      case 2 : this.ssgj = 2 //中国
        break
      case 4 : this.ssgj = 4 //马来西亚
        break
      case 3 : this.ssgj = 3 //印度尼西亚
        break
      case 7 : this.ssgj = 7 //泰国
        break
      case 5 : this.ssgj = 5 //菲律宾
        break
      case 6 : this.ssgj = 6 //新加坡
        break
      case 8 : this.ssgj = 8 //文莱
        break
      case 9 : this.ssgj = 9 //越南
        break
      case 10 : this.ssgj = 10 //老挝
        break
      case 11 : this.ssgj = 11 //缅甸
        break
      case 12 : this.ssgj = 12 //柬埔寨
        break
      case 13 : this.ssgj = 13 //其他
        break
      }
    },
    //获取国家概况
    getCountries()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 43, _exp: 'id=?', types: 'i', vals: this.ID}
      window.post.getPost(paras1).then((ret) =>
      {
        this.introducedata = ret[0]
      })
      //点击更多后的详情文章内容
      let paras2 = {cmd: 'query', _major: 11, _minor: 44, _exp: 'id=?', types: 'i', vals: this.ID}
      window.post.getPost(paras2).then((ret) =>
      {
        this.introduceContent = ret[0].content
      })
    },
    // 获取资讯动态
    getNewsdata()
    {
      //获取资讯动态（矿业资讯里面的内容）
      let paras1 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 6}
      window.post.getPost(paras1).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg', time: item.addtime, copyfrom: item.copyfrom, hits: item.hits})
        })
        this.informationdata = temp.sort(arrayFun.compareBtoS('time'))
      })
    },
    // 获取矿业资讯相关数据
    getLatest()
    {
      //获取地质矿产
      let paras11 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'catid=99 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'catid DESC', init: 0, pageno: 1, pagesize: 7}
      window.post.getPost(paras11).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, catid: item.catid})
        })
        
        this.DZKYdata = temp
      })
      //获取政策法规
      let paras22 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'catid=100 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'catid DESC', init: 0, pageno: 1, pagesize: 7}
      window.post.getPost(paras22).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, catid: item.catid})
        })
        this.ZCFGdata = temp
      })
      //获取投资环境
      let paras33 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'catid=101 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'catid DESC', init: 0, pageno: 1, pagesize: 7}
      window.post.getPost(paras33).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, catid: item.catid})
        })
        this.TZHJdata = temp
      })
    },
    // 获取矿业项目数据
    getminingdata()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 12, _exp: 'typeid=0 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras1).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id,
            title: item.company,
            content: item.title,
            time: item.addtime,
            copyfrom: item.copyfrom,
            hits: item.hits,
            tag: item.tag,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
        this.miningdatas = temp
      })
    },
    // 获取Tab数据
    getListdata()
    {
      //获取矿产品供应
      let paras1 = {cmd: 'query', _major: 11, _minor: 14, _exp: 'typeid=0 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras1).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list1.tabsList[0].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿产品', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list1.tabsList[0].listdata = temp
        }
      })
      //获取矿产品求购
      let paras2 = {cmd: 'query', _major: 11, _minor: 14, _exp: ' typeid=1 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras2).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list1.tabsList[1].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿产品', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list1.tabsList[1].listdata = temp
        }
      })
      //获取珠宝玉石供应
      let paras3 = {cmd: 'query', _major: 11, _minor: 16, _exp: 'typeid=0 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras3).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list2.tabsList[0].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '珠宝玉石', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list2.tabsList[0].listdata = temp
        }
      })
      //获取珠宝玉石求购
      let paras4 = {cmd: 'query', _major: 11, _minor: 16, _exp: 'typeid=1 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras4).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list2.tabsList[1].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '珠宝玉石', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list2.tabsList[1].listdata = temp
        }
      })
      //获取矿业设备供应
      let paras5 = {cmd: 'query', _major: 11, _minor: 18, _exp: 'typeid=0 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras5).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list3.tabsList[0].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿业设备', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list3.tabsList[0].listdata = temp
        }
      })
      //获取矿业设备求购
      let paras6 = {cmd: 'query', _major: 11, _minor: 18, _exp: 'typeid=1 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras6).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list3.tabsList[1].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿业设备', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list3.tabsList[1].listdata = temp
        }
      })
      //获取矿业技术供应
      let paras7 = {cmd: 'query', _major: 11, _minor: 20, _exp: 'typeid=0 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras7).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list4.tabsList[0].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿业技术', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list4.tabsList[0].listdata = temp
        }
      })
      //获取矿业技术求购
      let paras8 = {cmd: 'query', _major: 11, _minor: 20, _exp: 'typeid=1 and ssgj=? and examine = 0', types: 'i', vals: this.ssgj, orderby: 'typeid DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras8).then((ret) =>
      {
        if (ret[0].data.length === 0)
          this.list4.tabsList[1].listdata = []
        else
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, tag: item.tag, type: '矿业技术', thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.list4.tabsList[1].listdata = temp
        }
      })
    },
    //跳转矿业论坛详情页面
    KyzxDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转资料库详情页面
    ZlkDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转国家详情页面
    DmkyDetails(Introduce)
    {
      let url = this.$router.resolve({path: '/DmkyDetails', query: {id: Introduce}})
      window.open(url.href, '_blank')
    },
    //跳转矿业项目列表页
    goKYXMList()
    {
      let url = this.$router.resolve({path: '/HzxmKYXMList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业项目详情页
    goKYXMDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿产品列表页
    goKCPList()
    {
      let url = this.$router.resolve({path: '/HzxmKCPList'})
      window.open(url.href, '_blank')
    },
    //跳转矿产品详情页
    goKCPDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转珠宝玉石列表页
    goZBYSList()
    {
      let url = this.$router.resolve({path: '/HzxmZBYSList'})
      window.open(url.href, '_blank')
    },
    //跳转珠宝玉石详情页
    goZBYSDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业设备列表页
    goKYSBList()
    {
      let url = this.$router.resolve({path: '/HzxmKYSBList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业设备详情页
    goKYSBDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业技术列表页
    goKYJSList()
    {
      let url = this.$router.resolve({path: '/HzxmKYJSList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业技术详情页
    goKYJSDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYJSDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转到矿业信息地图
    goMap()
    {
      let url = this.$router.resolve({path: '/KyyztModule'})
      // let url = this.$router.resolve({path: '/Kyyztoply'})
      window.open(url.href, '_blank')
    },
    //资讯动态查看更多
    goKYZXList()
    {
      let url = this.$router.resolve({path: '/KyzxList', query: {catid: 1, ssgj: this.ID}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Dmky.vue